import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { PackageProduct, Package } from 'types/package';
import PackageProductsList from './list/PackageProductsList';
import PackageProductForm from './form/PackageProductForm';
import ConfirmDialog from 'components/confirm-dialog/ConfirmDialog';
import { countLabel, RecordToolbar } from 'components/record-shell/RecordList';

interface PackageProductsProps {
  pkg: Package;
  handleChangeAddProduct(product: PackageProduct): void;
  handleDeleteProduct(product: PackageProduct): void;
}

const PackageProducts: React.FC<PackageProductsProps> = ({ pkg, handleDeleteProduct, handleChangeAddProduct }) => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<PackageProduct | null>(null);
  const [productInfo, setProductInfo] = useState<PackageProduct>({
    product_id: 0,
    id: 0,
    quantity: 0,
    product: null,
  });

  function handleChangeProductInfo<K extends keyof PackageProduct>(index: K, value: PackageProduct[K] | string) {
    setProductInfo(prev => ({ ...prev, [index]: value }));
  }

  function handleAddProduct(productInfo: PackageProduct | null) {
    if (!productInfo) return;
    handleChangeAddProduct(productInfo);
    setAddDialogOpen(false);
    setProductInfo({
      product_id: 0,
      id: 0,
      quantity: 0,
      product: null,
    });
  }

  function onExited() {
    setAddDialogOpen(false);
    setProductInfo({
      product_id: 0,
      id: 0,
      quantity: 0,
      product: null,
    });
    setEditDialogOpen(false);
  }

  function handleEditProduct(product: PackageProduct, index: number) {
    setEditDialogOpen(true);
    setProductInfo(product);
  }

  return (
    <Grid container size={12} spacing={2}>
      {confirmDialogOpen && (
        <ConfirmDialog
          confirmLabel="Excluir"
          destructive
          handleNoClick={() => setConfirmDialogOpen(null)}
          handleYesClick={() => {
            handleDeleteProduct(confirmDialogOpen);
            setConfirmDialogOpen(null);
          }}
          title="Tem certeza que deseja excluir este produto?"
        />
      )}
      <Grid size={12}>
        <RecordToolbar
          title={countLabel(pkg.products.length, 'produto', 'produtos', 'Nenhum produto')}
          addLabel="Adicionar produto"
          onAdd={() => setAddDialogOpen(true)}
        />
      </Grid>

      {pkg.products.length > 0 && (
        <Grid size={12}>
          <PackageProductsList
            products={pkg.products}
            handleDeleteProduct={item => setConfirmDialogOpen(item)}
            handleEditProduct={handleEditProduct}
          />
        </Grid>
      )}

      {addDialogOpen && (
        <PackageProductForm
          type="new"
          handleChangeProductInfo={handleChangeProductInfo}
          productInfo={productInfo}
          handleAddProduct={handleAddProduct}
          onExited={onExited}
        />
      )}

      {/* Formulário de Edição de Produto */}
      {!!productInfo.id && editDialogOpen && (
        <PackageProductForm
          type="edit"
          handleChangeProductInfo={handleChangeProductInfo}
          productInfo={productInfo}
          handleAddProduct={handleAddProduct}
          onExited={onExited}
        />
      )}
    </Grid>
  );
};

export default PackageProducts;
